import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e666d65"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "row"
}
const _hoisted_2 = { class: "row position-relative" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "row g-0 pe-0 pe-md-15" }
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src", "onClick"]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "row h-100 p-0 position-relative" }
const _hoisted_10 = {
  key: 0,
  class: "col col-lg-4 col-xl-3 p-0 px-md-20 ps-md-30 pt-md-20 mx-md-20 ms-md-10 mx-lg-0"
}
const _hoisted_11 = { class: "ms-lg-10 mb-md-20 mt-40" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = ["src"]
const _hoisted_14 = ["src", "onClick"]
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = { class: "d-block col-lg-8 col-xl-9 p-0" }
const _hoisted_17 = ["data-lat", "data-lng"]
const _hoisted_18 = {
  key: 0,
  id: "around-me-container",
  class: "controls d-block w-100 px-15 d-flex flex-column"
}
const _hoisted_19 = {
  id: "radiusLabel",
  class: "mb-5 px-20 d-flex justify-content-center"
}
const _hoisted_20 = { class: "bg-white text-body f-14 px-10 py-5 font-weight-medium radius-5 lbl text-center" }
const _hoisted_21 = { class: "bg-transparent px-0 py-10 f-14 position-relative d-block overflow-hidden flex-grow-1 px-20" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_button = _resolveComponent("base-button")!
  const _component_base_autocomplete = _resolveComponent("base-autocomplete")!
  const _component_base_alert = _resolveComponent("base-alert")!
  const _component_base_bt_modal = _resolveComponent("base-bt-modal")!

  return (_openBlock(), _createBlock(_component_base_bt_modal, {
    id: "map-modal",
    "data-cy": "map-modal",
    style: {"z-index":"1053"},
    "show-modal": _ctx.openMapModal,
    "with-close-icon": true,
    "custom-modal-body-classes": "p-0 position-relative",
    "custom-modal-content-classes": "p-0 overflow-hidden",
    "custom-modal-header-classes": _ctx.headerClasses,
    "full-height": true,
    "close-on-click-out": false,
    onClosed: _ctx.hideMapModal
  }, _createSlots({
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_9, [
        (_ctx.isLarge)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createVNode(_component_base_button, {
                type: "button",
                class: "close m-0 p-0 p-md-5 position-absolute start-0 top-0 mt-10 ms-30",
                "icon-name": "close.svg",
                "icon-class": "icon-md",
                "btn-class": "d-none d-md-flex bg-transparent w-auto",
                onClick: _withModifiers(_ctx.closeMapModal, ["stop","prevent"])
              }, null, 8 /* PROPS */, ["onClick"]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("h3", {
                  class: "text-w-black f-22",
                  innerHTML: _ctx.labels.drawOnMap
                }, null, 8 /* PROPS */, _hoisted_12),
                _createVNode(_component_base_autocomplete, {
                  id: "map-modal_autocomplete_places_desktop",
                  "label-text": _ctx.labels.searchPlace,
                  "model-value": _ctx.currentAddress,
                  "on-input-change-cb": _ctx.onInputChangeCb,
                  "on-option-selected-cb": _ctx.optionSelectedCb,
                  "disable-cb": _ctx.autocompleteDisabled,
                  onChangedValue: _cache[2] || (_cache[2] = v => _ctx.currentAddress = v),
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.autocompleteDisabled = false))
                }, {
                  lefticon: _withCtx(() => [
                    _createElementVNode("img", {
                      src: `${_ctx.cdn}/_ui/img/Ico/zoom-blue.svg`,
                      alt: "cerca",
                      class: "text-input-icon left sm"
                    }, null, 8 /* PROPS */, _hoisted_13)
                  ]),
                  righticon: _withCtx(({handleClean}) => [
                    (_ctx.currentAddress.length > 0)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: `${_ctx.cdn}/_ui/img/Ico/close.svg`,
                          class: "text-input-icon right sm",
                          alt: "Clean Icon",
                          onClick: _withModifiers(($event: any) => {handleClean();}, ["stop"])
                        }, null, 8 /* PROPS */, _hoisted_14))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label-text", "model-value", "on-input-change-cb", "on-option-selected-cb", "disable-cb"])
              ]),
              (_ctx.browserSupportGeolocation() && !_ctx.aroundMe)
                ? (_openBlock(), _createBlock(_component_base_button, {
                    key: 0,
                    id: "desktopGpsButtonRow",
                    "btn-class": "btn-link text-w-black text-decoration-none ps-10 pt-5",
                    "icon-class": "icon-md me-10",
                    "icon-name": "geolocation.svg",
                    onClick: _withModifiers(_ctx.getPosition, ["stop"])
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", {
                        innerHTML: _ctx.labels.useMyPosition
                      }, null, 8 /* PROPS */, _hoisted_15)
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["onClick"]))
                : _createCommentVNode("v-if", true)
            ]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", {
            id: "map-container",
            class: _normalizeClass(["map-container h-100 w-100 bg-white pe-md-10", {'map-error' : _ctx.mapError}])
          }, [
            _createCommentVNode("        v-if=\"browserSupportGeolocation && !aroundMe\"    "),
            (_ctx.browserSupportGeolocation() && !_ctx.aroundMe && !_ctx.isDesktopMode)
              ? (_openBlock(), _createBlock(_component_base_button, {
                  key: 0,
                  id: "gpsButton",
                  "btn-class": "btn-white bg-white radius-50 box-shadow-light",
                  "icon-class": "icon-lg",
                  "icon-name": "gps-blue.svg",
                  onClick: _withModifiers(_ctx.getPosition, ["stop"])
                }, null, 8 /* PROPS */, ["onClick"]))
              : _createCommentVNode("v-if", true),
            (_ctx.mapError || _ctx.mapWarning)
              ? (_openBlock(), _createBlock(_component_base_alert, {
                  key: 1,
                  id: "map-error",
                  "alrt-class": "alert-danger text-center my-10 border border-w-danger rounded position-absolute",
                  text: _ctx.labelText
                }, null, 8 /* PROPS */, ["text"]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", {
              id: "leaflet-map-container",
              ref: "mapPlaceholder",
              class: _normalizeClass(["map polygon-draw", {'min-h-desktop' : _ctx.isDesktop }]),
              "data-layers": "",
              "data-drawing-manager": "POLYGON",
              "data-lat": _ctx.center.lat.toString(),
              "data-lng": _ctx.center.lng.toString(),
              style: _normalizeStyle(`background-image: url(${_ctx.cdn}/_ui/img/placeholders/map_italy_placeholder.webp); z-index: 0; border-bottom-right-radius: 20px; border-top-right-radius: 20px;`)
            }, null, 14 /* CLASS, STYLE, PROPS */, _hoisted_17)
          ], 2 /* CLASS */)
        ])
      ]),
      (_ctx.aroundMe)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.currentRadiusKm) + " km ", 1 /* TEXT */)
            ]),
            _createElementVNode("div", _hoisted_21, [
              _withDirectives(_createElementVNode("input", {
                id: "aroundMeSlider",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.currentRadius) = $event)),
                type: "range",
                min: "1000",
                max: "5000",
                step: "1000",
                class: _normalizeClass(['position-' + _ctx.currentRadiusKm, "position-relative me-20 w-100"])
              }, null, 2 /* CLASS */), [
                [
                  _vModelText,
                  _ctx.currentRadius,
                  void 0,
                  { number: true }
                ]
              ])
            ])
          ]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", {
        id: "map-actions-container",
        class: _normalizeClass(["d-flex position-absolute justify-content-center align-items-center px-10 px-md-0 me-md-40", {'hasPolygon': _ctx.hasPolygon}])
      }, [
        (!_ctx.mapDrawing && !_ctx.aroundMe)
          ? (_openBlock(), _createBlock(_component_base_button, {
              id: "start-drawing-btn",
              key: "start-drawing-btn",
              class: "btn-w-primary",
              onClick: _withModifiers(_ctx.startDrawing, ["stop"])
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.labels.clickToDrawOnMap), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["onClick"]))
          : _createCommentVNode("v-if", true),
        (_ctx.hasPolygon && !_ctx.aroundMe)
          ? (_openBlock(), _createBlock(_component_base_button, {
              id: "delete-polygon-btn",
              key: "delete-polygon-btn",
              "btn-class": "btn-outline-w-danger btn-md me-20",
              onClick: _ctx.deletePolygon,
              innerHTML: _ctx.labels.delete
            }, null, 8 /* PROPS */, ["onClick", "innerHTML"]))
          : _createCommentVNode("v-if", true),
        _createCommentVNode("            Draw map"),
        (_ctx.hasPolygon && !_ctx.aroundMe && !_ctx.mapError)
          ? (_openBlock(), _createBlock(_component_base_button, {
              id: "confirm-polygon-btn",
              ref: "confirmMap",
              key: "confirm-polygon-btn",
              "is-loading": _ctx.loading,
              "btn-class": "btn-md btn-w-primary ms-20",
              onClick: _ctx.confirmPolygon,
              innerHTML: _ctx.labels.confirm
            }, null, 8 /* PROPS */, ["is-loading", "onClick", "innerHTML"]))
          : _createCommentVNode("v-if", true),
        (_ctx.aroundMe)
          ? (_openBlock(), _createBlock(_component_base_button, {
              id: "delete-polygon-aroundme-btn",
              key: "delete-polygon-aroundme-btn",
              "btn-class": "btn-md btn-outline-w-danger",
              onClick: _ctx.deletePolygonAndCloseModal,
              innerHTML: _ctx.labels.backwards
            }, null, 8 /* PROPS */, ["onClick", "innerHTML"]))
          : _createCommentVNode("v-if", true),
        _createCommentVNode("            Around me"),
        (_ctx.aroundMe && !_ctx.mapError)
          ? (_openBlock(), _createBlock(_component_base_button, {
              id: "confirm-polygon-aroundme-btn",
              ref: "confirmMapAroundMe",
              key: "confirm-polygon-aroundme-btn",
              "is-loading": _ctx.loading,
              "btn-class": "btn-md btn-w-primary ms-20",
              onClick: _ctx.confirmAndSearchPolygon,
              innerHTML: _ctx.labels.confirm
            }, null, 8 /* PROPS */, ["is-loading", "onClick", "innerHTML"]))
          : _createCommentVNode("v-if", true)
      ], 2 /* CLASS */)
    ]),
    _: 2 /* DYNAMIC */
  }, [
    (!_ctx.isLarge)
      ? {
          name: "header",
          fn: _withCtx(() => [
            (!_ctx.aroundMe)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("h4", {
                      class: "text-w-black",
                      innerHTML: _ctx.labels.drawOnMap
                    }, null, 8 /* PROPS */, _hoisted_3),
                    (!_ctx.isDesktopMode)
                      ? (_openBlock(), _createBlock(_component_base_button, {
                          key: 0,
                          id: "closeIcon",
                          type: "button",
                          "btn-class": "bg-transparent d-none w-auto mt-10 ms-20 ms-lg-0 me-20 end-0",
                          "icon-name": "close.svg",
                          "icon-class": "icon-md",
                          onClick: _ctx.closeMapModal
                        }, null, 8 /* PROPS */, ["onClick"]))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_base_autocomplete, {
                      id: "map-modal_autocomplete_places",
                      "label-text": _ctx.labels.searchPlace,
                      "model-value": _ctx.currentAddress,
                      "on-input-change-cb": _ctx.onInputChangeCb,
                      "on-option-selected-cb": _ctx.optionSelectedCb,
                      "disable-cb": _ctx.autocompleteDisabled,
                      onChangedValue: _cache[0] || (_cache[0] = v => _ctx.currentAddress = v),
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.autocompleteDisabled = false))
                    }, {
                      lefticon: _withCtx(() => [
                        _createElementVNode("img", {
                          src: `${_ctx.cdn}/_ui/img/Ico/zoom-blue.svg`,
                          alt: "cerca",
                          class: "text-input-icon left sm"
                        }, null, 8 /* PROPS */, _hoisted_5)
                      ]),
                      righticon: _withCtx(({handleClean}) => [
                        (_ctx.currentAddress.length > 0)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: `${_ctx.cdn}/_ui/img/Ico/close.svg`,
                              class: "text-input-icon right sm",
                              alt: "Clean Icon",
                              onClick: _withModifiers(($event: any) => {handleClean();}, ["stop"])
                            }, null, 8 /* PROPS */, _hoisted_6))
                          : _createCommentVNode("v-if", true)
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["label-text", "model-value", "on-input-change-cb", "on-option-selected-cb", "disable-cb"])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("h4", {
                    class: "text-w-black",
                    innerHTML: _ctx.labels.closeOnYou
                  }, null, 8 /* PROPS */, _hoisted_8)
                ]))
          ]),
          key: "0"
        }
      : undefined
  ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["show-modal", "custom-modal-header-classes", "onClosed"]))
}